/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { HotToastService } from '@ngneat/hot-toast';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import dayjs from 'dayjs';
import moment from 'moment';
@Component({
  selector: 'edit-due-date.component',
  templateUrl: './edit-due-date.component.html',
  styleUrls: ['./edit-due-date.component.scss']
})
export class UpdateDueDateComponent implements OnInit {
  updateDueDateForm: UntypedFormGroup;
  jobDetails: any;
  clearSchedule: boolean = false;
  formSubmitted: boolean = false;
  updateDueDateAndClearSchedule: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UpdateDueDateComponent>,
    private dataCollectorService: DataCollectorService,
    private jobService: JobsService,
    private toast: HotToastService,
    public utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public data: any){}


  ngOnInit(): void {
    this.jobDetails = this.data?.data;
    this.clearSchedule = this.data?.clearSchedule;
    this.updateDueDateAndClearSchedule = this.data?.updateDueDateAndClearSchedule;
    const tz = this.utilityService.isEmptyOrUndefined(this.jobDetails.job_timezone) ? this.utilityService.preferredTimeZone : this.jobDetails.job_timezone;
    this.updateDueDateForm = new UntypedFormGroup({
      due_date: new UntypedFormControl(this.jobDetails?.due_date ? moment.tz(moment.utc(this.jobDetails?.due_date),tz) : null,[Validators.required])
    });
    moment.tz.setDefault(tz);
  }

  submit(): void{
    this.formSubmitted = true;
    if(!this.updateDueDateForm.touched){
      this.dialogRef.close();
      return;
    }
    if(this.jobDetails?.due_date ){
      const dueDateControl: AbstractControl = this.updateDueDateForm.controls.due_date;
      dueDateControl.clearValidators();
      dueDateControl.updateValueAndValidity();
    }
    if(this.updateDueDateForm?.valid){
      const tz = this.utilityService.isEmptyOrUndefined(this.jobDetails.job_timezone) ? this.utilityService.preferredTimeZone : this.jobDetails.job_timezone;
      const payload: any = {
        job: {
          job_uid: this.jobDetails.job_uid,
          due_date:  moment.tz(moment(this.updateDueDateForm?.value?.due_date),tz).endOf('day')?.utc()?.format('YYYY-MM-DD HH:mm:ss')
        }
      };
      if (this.clearSchedule && this.utilityService.isTimeZoneEnabled === false) {
        payload.job['job_timezone'] = null;
      }
      const loader = this.toast?.loading(this.utilityService.getLocaleValue('update.job.details.loader.text'));
      this.dataCollectorService.putData(`${this.jobService?.jobAPIUrls?.jobsUrl}?clear_schedule=${this.clearSchedule}`,payload).subscribe((resposne: any)=>{
        loader.close();
        this.toast.success(resposne?.message);
        this.dialogRef.close(true);
      },(error: any)=>{
        loader.close();
      });
    }
  }

  get minDate(): any{
    return moment().format();
  }

}


